import { Injectable, Provider } from '@angular/core';
import { QuestionSubmitReadyService } from '@examdojo/question';

@Injectable()
export class MultiAttemptQuestionSubmitReadyService extends QuestionSubmitReadyService {}

export function provideMultiAttemptQuestionSubmitReady(): Provider[] {
  return [
    MultiAttemptQuestionSubmitReadyService,
    { provide: QuestionSubmitReadyService, useExisting: MultiAttemptQuestionSubmitReadyService },
  ];
}
